// assets/popular-words-bar.js
// Popular Words Bar
// ・ヘッダーのすぐ下に固定（ヘッダーの高さを計算）
// ・×ボタンで閉じる（そのページでは復活しない）
// ・スクロール方向で表示/非表示
//   - 下スクロール：非表示
//   - 上スクロール：再表示

document.addEventListener("DOMContentLoaded", function () {
  var bar = document.querySelector("[data-popular-words-bar]");
  if (!bar) return;

  var closeBtn = bar.querySelector("[data-popular-words-close]");
  var hideOnScroll = bar.dataset.hideOnScroll === "true";

  var lastScrollY = window.scrollY;
  var permanentlyHidden = false;

  function updateOffset() {
    // Prestige のヘッダーセクションを取得
    var headerSection = document.querySelector(".shopify-section--header");
    if (!headerSection) return;

    var rect = headerSection.getBoundingClientRect();
    var headerHeight = rect.height;

    // ページ全体のスクロール位置を加味して高さを再計算したい場合は
    // getBoundingClientRect ではなく offsetHeight でもOK
    if (!headerHeight || headerHeight < 40) {
      headerHeight = headerSection.offsetHeight;
    }

    bar.style.setProperty("--popular-words-top", headerHeight + "px");
  }

  function showBar() {
    if (permanentlyHidden) return;
    bar.classList.remove("PopularWordsBar--hidden");
  }

  function hideBar() {
    if (permanentlyHidden) return;
    bar.classList.add("PopularWordsBar--hidden");
  }

  function onScroll() {
    if (!hideOnScroll || permanentlyHidden) return;

    var currentY = window.scrollY;
    var delta = currentY - lastScrollY;

    // ほぼトップなら常に表示
    if (currentY < 10) {
      showBar();
      lastScrollY = currentY;
      return;
    }

    // 下スクロール → 非表示
    if (delta > 5) {
      hideBar();
    }
    // 上スクロール → 表示
    else if (delta < -5) {
      showBar();
    }

    lastScrollY = currentY;
  }

  // ×ボタンで完全に閉じる
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      permanentlyHidden = true;
      bar.classList.add("PopularWordsBar--hidden");
      window.removeEventListener("scroll", onScroll);
    });
  }

  // 初期状態：ヘッダー高さに合わせて配置
  updateOffset();
  showBar();

  if (hideOnScroll) {
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  // ウィンドウサイズが変わったときなどにヘッダー高さを再計算
  window.addEventListener("resize", function () {
    updateOffset();
  });
});